var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62,
    height: 38,
    viewBox: "0 0 62 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.003,
    y1: 0.146,
    x2: 0.815,
    y2: 0.626,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#032037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.171,
    y1: 0.403,
    x2: 1.424,
    y2: 0.745,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#ac6300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#905300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#5d3500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#341e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.954,
    stopColor: "#170d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#060300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3468",
    "data-name": "Group 3468",
    transform: "translate(-222.506 -123.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5273",
    "data-name": "Path 5273",
    d: "M262.815,124.205,240.5,160.782h-9.912l-8.082-36.577h10.319l5.083,23.775,14.538-23.775Z",
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5274",
    "data-name": "Path 5274",
    d: "M255.472,160.4a21.343,21.343,0,0,1-6.455-2.819l3.964-7.725a21.654,21.654,0,0,0,5.745,2.688,21.164,21.164,0,0,0,6.1.914,9.627,9.627,0,0,0,4.5-.862,2.626,2.626,0,0,0,1.6-2.375,2.244,2.244,0,0,0-1.448-2.036,25.933,25.933,0,0,0-4.5-1.565,46.055,46.055,0,0,1-5.744-1.906,10.252,10.252,0,0,1-3.94-2.949,7.889,7.889,0,0,1-1.652-5.22,11.588,11.588,0,0,1,2.085-6.865,13.39,13.39,0,0,1,5.947-4.567,23.3,23.3,0,0,1,9.048-1.618,29.877,29.877,0,0,1,7.116.809,19.035,19.035,0,0,1,5.693,2.323l-3.66,7.673a16.555,16.555,0,0,0-4.6-2.062,19.056,19.056,0,0,0-5.159-.7,9.378,9.378,0,0,0-4.7.992,2.922,2.922,0,0,0-1.7,2.558,2.273,2.273,0,0,0,1.474,2.088,26.593,26.593,0,0,0,4.575,1.566,43.491,43.491,0,0,1,5.719,1.827,10.1,10.1,0,0,1,3.888,2.871,7.6,7.6,0,0,1,1.627,5.063,11.408,11.408,0,0,1-2.11,6.812,13.535,13.535,0,0,1-6,4.568,23.353,23.353,0,0,1-9.022,1.617A31.334,31.334,0,0,1,255.472,160.4Z",
    transform: "translate(0.975)",
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVs);
export default __webpack_public_path__ + "static/media/vs.7d7656df.svg";
export { ForwardRef as ReactComponent };